// src/components/RhinoVOIPContainer.jsx
import React, { useState, useEffect } from 'react';
import RhinoVOIPDialPad from './RhinoVOIPDialPad';
import RhinoVOIPRecentCalls from './RhinoVOIPRecentCalls';
import RhinoVOIPVoicemails from './RhinoVOIPVoicemails';

import '../assets/styles/rhinovoip-container.less';
import voicemailIcon from '../assets/images/voip/tab-voicemail.svg';
import recentsIcon from '../assets/images/voip/tab-recents.svg';
import dialpadIcon from '../assets/images/voip/tab-dialpad.svg';

export default function RhinoVOIPContainer() {
  const [activeTab, setActiveTab] = useState('dialpad');
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile && activeTab === 'dialpad') {
        setActiveTab('recents'); // <-- fix
      }
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, [activeTab]);

  const renderContent = () => {
    switch (activeTab) {
      case 'recents':
        return <RhinoVOIPRecentCalls />;
      case 'voicemail':
        return <RhinoVOIPVoicemails />;
      default:
        return <RhinoVOIPDialPad />;
    }
  };

  return (
    <div className={`voip-container ${isMobile ? 'mobile' : 'desktop'}`}>
      {isMobile ? (
        <>
          <div className="voip-content">{renderContent()}</div>
          <div className="voip-tabs bottom-tabs">
            <button type="button" className={activeTab === 'dialpad' ? 'active' : ''} onClick={() => setActiveTab('dialpad')}>
              <img src={dialpadIcon} alt="Dialpad" className="tab-icon" />
              <span>Dialpad</span>
            </button>
            <button type="button" className={activeTab === 'recents' ? 'active' : ''} onClick={() => setActiveTab('recents')}>
              <img src={recentsIcon} alt="Recents" className="tab-icon" />
              <span>Recents</span>
            </button>
            <button type="button" className={activeTab === 'voicemail' ? 'active' : ''} onClick={() => setActiveTab('voicemail')}>
              <img src={voicemailIcon} alt="Voicemail" className="tab-icon" />
              <span>Voicemail</span>
            </button>
          </div>
        </>
      ) : (
        <div className="voip-layout">
          <div className="voip-left">
            <RhinoVOIPDialPad />
          </div>
          <div className="voip-right">
            <div className="voip-tabs top-tabs">
              <button type="button" className={activeTab === 'recents' ? 'active' : ''} onClick={() => setActiveTab('recents')}>
                <img src={recentsIcon} alt="Recents" className="tab-icon" />
                <span>Recents</span>
              </button>
              <button type="button" className={activeTab === 'voicemail' ? 'active' : ''} onClick={() => setActiveTab('voicemail')}>
                <img src={voicemailIcon} alt="Voicemail" className="tab-icon" />
                <span>Voicemail</span>
              </button>
            </div>
            <div className="voip-panel-content">{renderContent()}</div>
          </div>
        </div>
      )}
    </div>
  );
}
